<template>
  <v-tabs v-model="tabMenu">
    <v-tabs-slider color="primary"></v-tabs-slider>
    <v-tab @click="resetTab()">Policies</v-tab>
    <v-tab @click="doFetchClaim">Claims</v-tab>
    <v-tab @click="doFetchAccount">Accounts</v-tab>
    <v-tab @click="doFetchComm">Commission</v-tab>
    <v-tab v-show="policyQueryTab" >{{ 'Query Policy' }}</v-tab>
    <v-tab v-show="claimQueryTab" >{{ 'Query Claim' }}</v-tab>
    <v-tab v-show="accountQueryTab" >{{ 'Query Account' }}</v-tab>
    <v-tab v-show="commQueryTab" >{{ 'Query Commission' }}</v-tab>
    <v-tab-item>
      <policy-list :fetchPolicy="fetchPolicy" :inter="inter" :interGroupCode="interGroupCode" @resetTab="resetTab" @doQuery="doPolicyQuery"></policy-list>
    </v-tab-item>
    <v-tab-item>
      <claim-list :fetchClaim="fetchClaim" :inter="inter" :interGroupCode="interGroupCode" @resetTab="resetTab"  @doQuery="doClaimQuery"></claim-list>
    </v-tab-item>
    <v-tab-item>
      <account-list :fetchAccount="fetchAccount" :inter="inter" @resetTab="resetTab" @doQuery="doAccountQuery"></account-list>
    </v-tab-item>
    <v-tab-item>
      <comm-list :fetchComm="fetchComm" :inter="inter" @resetTab="resetTab" @doQuery="doCommQuery"></comm-list>
    </v-tab-item>
    <v-tab-item>
      <policy-form :ids="ids" @resetTab="resetTab"></policy-form>
    </v-tab-item>
    <v-tab-item>
      <claim-form :ids="ids" @resetTab="resetTab"></claim-form>
    </v-tab-item>
    <v-tab-item>
      <account-form :ids="ids" @resetTab="resetTab"></account-form>
    </v-tab-item>
    <v-tab-item>
      <comm-form :ids="ids" @resetTab="resetTab"></comm-form>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import PolicyList from '../list/PolicyList'
import ClaimList from '../list/ClaimList'
import AccountList from '../list/AccountList'
import CommList from '../list/CommList'
import PolicyForm from '../form/PolicyForm'
import ClaimForm from '../form/ClaimForm'
import AccountForm from '../form/AccountForm'
import CommForm from '../form/CommForm'
import { ACCOUNTS_LOAD_DATA } from '@/store/types'

export default {
  data() {
    return {
      tabMenu: 0,
      policyQueryTab: false,
      claimQueryTab: false,
      accountQueryTab: false,
      commQueryTab: false,
      fetchPolicy: false,
      fetchClaim: false,
      fetchAccount: false,
      fetchComm: false,
      ids: {
        inter: null,
        interGroupCode: null,
        commissionNo: null,
        effDate: null,
        polType: null,
        ovrInter: null
      }
    }
  },
  computed: {
    schemeMenu() {
      return this.$store.state.parameters.scheme.schemeMenu
    }
  },
  mounted() {
    this.doInit()
  },
  methods: {
    async doInit() {
      await this.$store.dispatch('claimsInit')
      await this.$store.dispatch('claimsListingInit')
      await this.$store.dispatch('claimsRegisterInit')
      await this.$store.dispatch('accountsInit')
      await this.$store.dispatch('underwritingInit')
    },
    async resetTab(tab) {
      switch (tab) {
        case 4: {
          this.tabMenu = 3
          this.policyQueryTab = true
          this.claimQueryTab = true
          this.accountQueryTab = true
          this.commQueryTab = true
          this.fetchPolicy = false
          this.fetchClaim = false
          this.fetchAccount = false
          this.fetchComm = false
          break
        }
        case 3: {
          this.tabMenu = 2
          this.policyQueryTab = true
          this.claimQueryTab = true
          this.accountQueryTab = true
          this.commQueryTab = true
          this.fetchPolicy = false
          this.fetchClaim = false
          this.fetchAccount = false
          this.fetchComm = false
          break
        }
        case 2: {
          this.tabMenu = 1
          this.ids.ovrInter = null
          this.policyQueryTab = true
          this.claimQueryTab = true
          this.accountQueryTab = true
          this.commQueryTab = true
          this.fetchPolicy = false
          this.fetchClaim = false
          this.fetchAccount = false
          this.fetchComm = false
          break
        }
        default: {
          this.tabMenu = 0
          this.ids.commissionNo = null
          this.ids.effDate = null
          this.ids.polType = null
          this.policyQueryTab = false
          this.claimQueryTab = false
          this.accountQueryTab = false
          this.commQueryTab = false
          this.fetchPolicy = true
          this.fetchClaim = false
          this.fetchAccount = false
          this.fetchComm = false
        }
      }
    },
    async doPolicyQuery(data) {
      const convertPolicy = {
        item: {
          polNo: data.polNo,
          endtCnt: data.endtCnt,
          renCnt: data.renCnt
        }
      }
      await this.$store.dispatch('reviewPolicy', convertPolicy)

      this.ids.inter = this.inter
      this.ids.commissionNo = data.commissionNo
      this.ids.effDate = data.effDateTime
      this.ids.polType = data.polType
      this.policyQueryTab = true
      this.claimQueryTab = false
      this.accountQueryTab = false
      this.commQueryTab = false
      this.tabMenu = 4

      this.$router.push({ name: 'queryPolicy' })
    },
    async doClaimQuery(data) {
      const convertClaim = {
        clmNo: data.clmNo,
        query: false
      }
      await this.$store.dispatch('loadClaim', convertClaim)
      await this.$store.dispatch('claimEntryInit')

      this.ids.inter = this.inter
      this.ids.commissionNo = data.commissionNo
      this.ids.effDate = data.effDateTime
      this.ids.polType = data.polType
      this.policyQueryTab = false
      this.claimQueryTab = true
      this.accountQueryTab = false
      this.commQueryTab = false
      this.tabMenu = 5

      this.$router.push({ name: 'qClaimHeader', params: { claimNo: data.clmNo, clmNo: data.clmNo } })
    },
    async doAccountQuery(data) {
      const convertAccount = {
        branch: data.branch,
        acctNo: data.acctNo,
        type: data.tranType,
        docNo: data.docNo,
        fund: data.fund,
        suffix: data.acctNoSfx,
        rbcTran: data.rbcTran,
        osBalance: data.osBal,
        netAmount: data.netAmount
      }
      this.$store.commit(ACCOUNTS_LOAD_DATA, convertAccount)

      this.ids.inter = this.inter
      this.ids.commissionNo = data.commissionNo
      this.ids.effDate = data.effDateTime
      this.ids.polType = data.polType
      this.policyQueryTab = false
      this.claimQueryTab = false
      this.accountQueryTab = true
      this.commQueryTab = false
      this.tabMenu = 6

      this.$router.push({ name: 'accountsDetails', params: { accountData: data.item } })
    },
    doCommQuery(data) {
      this.ids.inter = this.inter
      this.ids.commissionNo = data.commissionNo
      this.ids.effDate = data.effDateTime
      this.ids.polType = data.polType
      this.policyQueryTab = false
      this.claimQueryTab = false
      this.accountQueryTab = false
      this.commQueryTab = true
      this.tabMenu = 7
    },
    doFetchClaim() {
      this.fetchClaim = true
      this.claimQueryTab = false
      this.policyQueryTab = false
      this.accountQueryTab = false
      this.commQueryTab = false
    },
    doFetchAccount() {
      this.fetchAccount = true
      this.claimQueryTab = false
      this.policyQueryTab = false
      this.accountQueryTab = false
      this.commQueryTab = false
    },
    doFetchComm() {
      this.fetchComm = true
      this.claimQueryTab = false
      this.policyQueryTab = false
      this.accountQueryTab = false
      this.commQueryTab = false
    }
  },
  components: {
    PolicyList,
    PolicyForm,
    ClaimList,
    ClaimForm,
    AccountList,
    AccountForm,
    CommList,
    CommForm
  },
  props: {
    inter: {
      type: String,
      default: ''
    },
    interGroupCode: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>

</style>
